import * as React from 'react';
const IconDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={18}
    style={{ width: 21, height: 18 }}
    viewBox="0 0 21 18"
    fill="none"
    {...props}
  >
    <path
      d="M4.3125 4H1.5V16H19.5V4H16.6875"
      stroke="#020000"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10.5 2L10.5 9" stroke="#020000" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.5 7L10.5 10L13.5 7" stroke="#020000" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default IconDownload;
